import { getFormattedPhoneNumber } from '../../../helpers';
import { IconButton } from '../../Shared';
import { DialPad } from './DialPad';

export const DialPadCall = ({
  phoneNumbers,
  phoneNumber,
  onChangePhoneNumber,
}) => {
  const handleChange = dialPadKey => {
    onChangePhoneNumber(prev => {
      if (prev.length === 10) return prev;
      return prev + dialPadKey;
    });
  };

  const handleClear = () => {
    onChangePhoneNumber(prev => prev.substring(0, prev.length - 1));
  };

  const isPhoneNumberExist = phoneNumbers.find(
    ({ PhoneNumber }) => PhoneNumber === phoneNumber,
  );

  return (
    <div className="w-full pb-5 pt-3 flex flex-col items-center justify-center gap-3 rounded-[20px] bg-white/30">
      <div className="w-60 flex flex-col items-center justify-end gap-1.5 h-[50px]">
        {isPhoneNumberExist && (
          <span className="text-base-800 text-[14px]/[18px]">
            This number already exists
          </span>
        )}
        <div className="w-full flex items-center justify-center relative h-[26px]">
          <span className="text-center text-brand-900 font-semibold text-[18px]/[26px] truncate px-6">
            {getFormattedPhoneNumber(phoneNumber)}
          </span>
          <IconButton
            buttonProps={{
              className: 'w-5 h-5 !absolute right-0',
              onClick: handleClear,
              disabled: !phoneNumber,
            }}
            iconProps={{
              name: 'backspace',
              alt: 'bs',
              className: 'h-5',
            }}
          />
        </div>
      </div>
      <DialPad onClick={handleChange} />
    </div>
  );
};
